import { ToolHeader } from './ToolHeader';

interface Props {
  icon: React.ElementType | string;
  title: string;
  subtitle?: string;
  badge?: string;
  badgeVariant?: 'gold' | 'violet' | 'premium';
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

export function ToolPageShell({ icon, title, subtitle, badge, badgeVariant, headerRight, children }: Props) {
  return (
    <div className="page-container">
      <ToolHeader
        icon={icon}
        title={title}
        subtitle={subtitle}
        badge={badge}
        badgeVariant={badgeVariant}
        right={headerRight}
      />
      {children}
    </div>
  );
}
